import React, { useState, useEffect } from 'react'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import { Form, Modal, Button } from 'react-bootstrap'
import axios from 'axios'
import { Map, GoogleApiWrapper, Marker} from 'google-maps-react';
import { useSelector } from 'react-redux'

const AzuriranjeScreen = (props) => {

  const [showModal, setShowModal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [mesta, setMesta] = useState([])
  const [mesto, setMesto] = useState(null)
  const [stubovi, setStubovi] = useState([])
  const [stub, setStub] = useState({})
  const [abr, setAbr] = useState('')
  const [num, setNum] = useState('')
  const [svetiljka, setSvetiljka] = useState('')
  const [snaga, setSnaga] = useState('')
  const [opis, setOpis] = useState('')
  const [dodaj, setDodaj] = useState(false)

  const userLogin = useSelector(state => state.userLogin)
  const { userInfo } = userLogin

  const iconBase =
  "http://maps.google.com/mapfiles/ms/icons/"


  useEffect(() => {
    if (mesto) {

      axios.get(`/api/stubovi/${mesto._id}`).then(item => {
        setStubovi(item.data)})
    }
  }, [userInfo, mesto])

  const searchHandler = (query) => {
    
    setIsLoading(true)

    if (userInfo) {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userInfo.token} `
        }
      }
  
      axios.get(`/api/mesta/?abr=${query}`, config).then(item => {
        setMesta(item.data)
        setIsLoading(false)
      })
  
    } 
  } 

  const submitHandler = (e) => {
    e.preventDefault()
  }

  const onCloseHandler = () => {
    setShowModal(false)
  }

  const onClickHandler = (k) => {

    axios.get(`/api/stubovi/stub/${k._id}`).then(item => {
      setStub(item.data)
      if(item.data.svetiljka){
        setSvetiljka(item.data.svetiljka)
        setSnaga(item.data.snaga)
        setOpis(item.data.Tekst)
      }else{
        setSvetiljka("")
        setSnaga("")
        setOpis("")
      }
    
    setShowModal(true)
    })

    
  }

  const submitFormHandler = (e) => {
    e.preventDefault()

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
      axios.put(`/api/stubovi/azuriranje/${stub._id}`, {svetiljka, snaga, opis}, config)
    
    setShowModal(false)
  }

  const filterBy = () => true

  return (
    <>
    {!mesto && <div>
      <AsyncTypeahead 
      filterBy={filterBy}
      id='basic-example' 
      labelKey='naziv'
      isLoading={isLoading}
      minLength={3}
      onSearch={searchHandler}
      options={mesta}
      placeholder='Izaberi grad'
      renderMenuItemChildren={(mesto) => (
        <div onClick={() => {
          setMesto(mesto)
        }}>
        <span>{mesto.naziv}</span>
        </div>
        
      )}
      />
    </div>}
    
   {mesto && 
   <>
   <Form onSubmit={submitHandler} inline>
       
   <Form.Control type='text' name='q' onChange={(e) => setAbr(e.target.value)} placeholder='Pretrazi adresu' className='mr-sm-2 ml-sm-5'></Form.Control>
   <Form.Control type='text' name='p' onChange={(e) => setNum(e.target.value)} placeholder='Pretrazi broj' className='mr-sm-2 ml-sm-5'></Form.Control>
    
 </Form> 
   <Map
    zoom={mesto.zoom}
    google={props.google}
   // style={mapStyles}
    mapType='satellite'
    initialCenter={
      {
        lat: mesto.center.lat,
        lng: mesto.center.lon
      }
    }
  >
    {!showModal && stubovi.filter(s => s.Adresa.toUpperCase().includes(abr.toUpperCase())).filter(f => f.Adresa.toUpperCase().split(' ').pop().includes(num.toUpperCase())).map(stub => (
      <Marker key={stub._id} position={{lat: stub.LAT, lng: stub.LON}} onClick={() => onClickHandler(stub)}  icon = {stub.svetiljka ? iconBase + 'green-dot.png' : iconBase + 'red-dot.png' } />
    )
    )}
  </Map>

  <Modal show={showModal} onHide={onCloseHandler}>
  <Modal.Header closeButton>
    <Modal.Title>Ažuriranje stuba</Modal.Title>
  </Modal.Header> 
  <Modal.Body>
    <Form onSubmit={submitFormHandler}>
      <p>Broj Stuba: {stub.Rbr}</p>
      <p>Adresa: {stub.Adresa}</p>
      <p>{stub.Tekst}</p>
      {/* {!stub.svetiljka && <h2>Stub je bez svetiljke</h2>} */}
        {!stub.svetiljka && 
        <>
        <p>Dodaj svetiljku   <Button variant='outline-success' onClick={() => setDodaj(true)}>+</Button></p>
        </>
        }
        <br/>
         {(stub.svetiljka || dodaj) && 
         <>
          <Form.Group controlId='svetiljka'>
          <Form.Label>Svetiljka</Form.Label>
          <Form.Control as='select' value={svetiljka} onChange={(e) => {
            setSvetiljka(e.target.value)
            console.log(e.target.value)}}>
            <option value='LED'>LED svetiljka</option>
            <option value='H'>Živina svetiljka</option>
            <option value='N'>Natrijumova svetiljka</option>
            <option value='MH'>Metal-Halogena svetiljka</option>
          </Form.Control>
          </Form.Group> 
          <Form.Group controlId='snaga'>
          <Form.Label>Snaga</Form.Label>
          <Form.Control type='text' placeholder={stub.snaga} value={snaga} onChange={(e) => {setSnaga(e.target.value)}}></Form.Control>
          </Form.Group>
          <Form.Group controlId='opis'>
          <Form.Label>Opis</Form.Label>
          <Form.Control as='textarea' row='6' placeholder={stub.Tekst} value={opis} onChange={(e) => {setOpis(e.target.value)}}></Form.Control>
          </Form.Group>
          <Button type='submit' variant='outline-success'>Ažuriraj</Button>
          </>} 
          
    </Form>
  </Modal.Body>
</Modal>
    </>
   } 
  </>
  )
}

export default GoogleApiWrapper({
  apiKey: 'AIzaSyACV2yMJcx_aByY3PwY1b59WvppbM9_ovc'
})(AzuriranjeScreen)
